import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {AUTH_TOKEN} from "../../../constants/AuthConstant";
import taliAsihService from "../../../services/ref/taliAsihService";
import Cookies from "js-cookie";

export const initialState = {
    loading_tali_asih: false,
    data_tali_asih: [],
    data_import: [],
    showMessage:false,
    message:'',
}

export const getDataTaliAsih = createAsyncThunk('tali_asih/data',async (data, { rejectWithValue }) => {
    try {
        const response = await taliAsihService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
    }
})

export const getaDataImport = createAsyncThunk('tali_asih/dataimport',async (data, { rejectWithValue }) => {
    try {
        const response = await taliAsihService.data_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const emptyDataImport = createAsyncThunk('tali_asih/emptyimport',async (data, { rejectWithValue }) => {
    try {
        const response = await taliAsihService.empty_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const saveDataImport = createAsyncThunk('tali_asih/saveimport',async (data, { rejectWithValue }) => {
    try {
        const response = await taliAsihService.save_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const taliAsihSlice = createSlice({
    name: 'tali_asih',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_tali_asih = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataTaliAsih.fulfilled, (state, action) => {
                state.loading_tali_asih = false
                state.data_tali_asih = action.payload??[]
            })
            .addCase(getDataTaliAsih.pending, (state) => {
                state.loading_tali_asih = true
            })
            .addCase(getDataTaliAsih.rejected, (state, action) => {
                state.loading_tali_asih = false
                state.data_tali_asih = action.payload
            })
            .addCase(getaDataImport.fulfilled, (state, action) => {
                state.loading_tali_asih = false
                state.data_import = action.payload??[]
            })
            .addCase(getaDataImport.pending, (state) => {
                state.loading_tali_asih = true
            })
            .addCase(getaDataImport.rejected, (state, action) => {
                state.loading_tali_asih = false
                state.data_import = action.payload
            })
    },
})

export const {
    showLoading,
} = taliAsihSlice.actions

export default taliAsihSlice.reducer
